var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _extends from "@babel/runtime/helpers/extends";
import { Autocomplete, MenuItem, TextField } from "@mui/material";
import { debounce } from '@mui/material';
import { useCallback, useMemo, useState } from "react";
import { getLabourListUrl, getPartListUrl } from "../../../../api/url";
import { showLoader } from "../../../../redux/commonSlice";
import { getListAPI } from "../../../../redux/crudSlice";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
var data = [{
        label: "Part",
        value: "Part"
    }, {
        label: "Labour",
        value: "Labour"
    }];
var SelectJobsComponent = function (props) {
    var onSelectOption = props.onSelectOption, isDisabled = props.isDisabled;
    var _a = useState(''), searchText = _a[0], setSearchText = _a[1];
    var _b = useState('Part'), selectedOption = _b[0], setSelectedOption = _b[1];
    //Define two state for partlist & labourList
    var _c = useState([]), partsList = _c[0], SetpartsList = _c[1];
    var _d = useState([]), laboursList = _d[0], SetLaboursList = _d[1];
    var _e = useState([]), autocompleteOptions = _e[0], setAutocompleteOptions = _e[1];
    var _f = useAppSelector(function (state) { return state.crud; }), ModuleDetailsGetById = _f.ModuleDetailsGetById, documentDetailsGetById = _f.documentDetailsGetById;
    var dispatch = useAppDispatch();
    var handleSearchChange = function (event) {
        // setSearchText(event.target.value);
        if (event.target.value.length > 2) {
            fetchData(event.target.value);
        }
        if (event.target.value == "") {
            setAutocompleteOptions([]);
        }
    };
    var sendRequest = useCallback(function (value) {
        console.log("ModuleDetailsGetBy8765erkj", ModuleDetailsGetById);
        handleSearchChange(value);
    }, [selectedOption, ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 ? void 0 : ModuleDetailsGetById.data]);
    // memoize the debounce call with useMemo
    var debouncedSendRequest = useMemo(function () {
        return debounce(sendRequest, 500);
    }, [sendRequest]);
    var onChange = function (e) {
        var value = e.target.value;
        setSearchText(value);
        debouncedSendRequest(e);
        //handleSearchChange(e)
    };
    var handleOptionChange = function (event) {
        setSelectedOption(event.target.value);
        setSearchText("");
        setAutocompleteOptions([]);
        // if (event.target.value === "Part") {
        //   setAutocompleteOptions([...partsList]); // Create a new array with the same elements
        // } else {
        //   setAutocompleteOptions([...laboursList]); // Create a new array with the same elements
        // }
    };
    var getPartList = function (searchValue) { return __awaiter(void 0, void 0, void 0, function () {
        var _ModuleDetailsGetById, _documentDetailsGetBy, _ModuleDetailsGetById2, _documentDetailsGetBy2, _ModuleDetailsGetById3, _documentDetailsGetBy3, _PartListData$payload, _PartListData$payload2, requestBody, PartListData, _PartListData$payload3, _PartListData$payload4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        OrganizationId: (ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById === void 0 ? void 0 : _ModuleDetailsGetById.OrganizationId) || (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy = documentDetailsGetById.data) === null || _documentDetailsGetBy === void 0 ? void 0 : _documentDetailsGetBy.OrganizationId) || "",
                        SourceAssociationId: (ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById2 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById2 === void 0 ? void 0 : _ModuleDetailsGetById2.ProductId) || (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy2 = documentDetailsGetById.data) === null || _documentDetailsGetBy2 === void 0 ? void 0 : _documentDetailsGetBy2.ProductId) || "",
                        //ProductId from Installbase
                        search: searchValue,
                        InstallBaseId: (ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById3 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById3 === void 0 ? void 0 : _ModuleDetailsGetById3.InstallBaseId) || (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy3 = documentDetailsGetById.data) === null || _documentDetailsGetBy3 === void 0 ? void 0 : _documentDetailsGetBy3.InstallBaseId) || ""
                    };
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: getPartListUrl,
                            request: requestBody
                        }))];
                case 1:
                    PartListData = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    if (PartListData !== null && PartListData !== void 0 && (_PartListData$payload = PartListData.payload) !== null && _PartListData$payload !== void 0 && (_PartListData$payload = _PartListData$payload.value) !== null && _PartListData$payload !== void 0 && _PartListData$payload.success && PartListData !== null && PartListData !== void 0 && (_PartListData$payload2 = PartListData.payload) !== null && _PartListData$payload2 !== void 0 && (_PartListData$payload2 = _PartListData$payload2.value) !== null && _PartListData$payload2 !== void 0 && _PartListData$payload2.data) {
                        SetpartsList((_PartListData$payload3 = PartListData.payload) === null || _PartListData$payload3 === void 0 || (_PartListData$payload3 = _PartListData$payload3.value) === null || _PartListData$payload3 === void 0 ? void 0 : _PartListData$payload3.data);
                        setAutocompleteOptions((_PartListData$payload4 = PartListData.payload) === null || _PartListData$payload4 === void 0 || (_PartListData$payload4 = _PartListData$payload4.value) === null || _PartListData$payload4 === void 0 ? void 0 : _PartListData$payload4.data);
                    }
                    else {
                        SetpartsList([]);
                        setAutocompleteOptions([]);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getLabourList = function (searchValue) { return __awaiter(void 0, void 0, void 0, function () {
        var _ModuleDetailsGetById4, _ModuleDetailsGetById5, _ModuleDetailsGetById6, _LabourListData$paylo, _LabourListData$paylo2, requestBody, LabourListData, _LabourListData$paylo3, _LabourListData$paylo4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        search: searchValue,
                        OrganizationId: (_ModuleDetailsGetById4 = ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById5 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById5 === void 0 ? void 0 : _ModuleDetailsGetById5.OrganizationId) !== null && _ModuleDetailsGetById4 !== void 0 ? _ModuleDetailsGetById4 : "",
                        ProductId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById6 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById6 === void 0 ? void 0 : _ModuleDetailsGetById6.ProductId
                    };
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: getLabourListUrl,
                            request: requestBody
                        }))];
                case 1:
                    LabourListData = _a.sent();
                    console.log("LabourListData", LabourListData);
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    if (LabourListData !== null && LabourListData !== void 0 && (_LabourListData$paylo = LabourListData.payload) !== null && _LabourListData$paylo !== void 0 && (_LabourListData$paylo = _LabourListData$paylo.value) !== null && _LabourListData$paylo !== void 0 && _LabourListData$paylo.success && LabourListData !== null && LabourListData !== void 0 && (_LabourListData$paylo2 = LabourListData.payload) !== null && _LabourListData$paylo2 !== void 0 && (_LabourListData$paylo2 = _LabourListData$paylo2.value) !== null && _LabourListData$paylo2 !== void 0 && _LabourListData$paylo2.data) {
                        SetLaboursList(LabourListData === null || LabourListData === void 0 || (_LabourListData$paylo3 = LabourListData.payload) === null || _LabourListData$paylo3 === void 0 || (_LabourListData$paylo3 = _LabourListData$paylo3.value) === null || _LabourListData$paylo3 === void 0 ? void 0 : _LabourListData$paylo3.data);
                        setAutocompleteOptions((_LabourListData$paylo4 = LabourListData.payload) === null || _LabourListData$paylo4 === void 0 || (_LabourListData$paylo4 = _LabourListData$paylo4.value) === null || _LabourListData$paylo4 === void 0 ? void 0 : _LabourListData$paylo4.data);
                    }
                    else {
                        SetLaboursList([]);
                        setAutocompleteOptions([]);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchData = function (searchValue) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                if (selectedOption === "Part") {
                    getPartList(searchValue);
                }
                else {
                    getLabourList(searchValue);
                }
            }
            catch (error) {
                console.error('Error fetching autocomplete options:', error);
            }
            return [2 /*return*/];
        });
    }); };
    return /*#__PURE__*/ React.createElement("div", {
        style: {
            display: "flex",
            width: "100%"
        }
    }, /*#__PURE__*/ React.createElement(TextField, {
        id: "job-type-select",
        fullWidth: true,
        size: "small",
        select: true,
        sx: {
            "& fieldset": {
                borderRight: "none",
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0
            },
            width: "40%",
            opacity: isDisabled ? 0.7 : 1
        },
        disabled: isDisabled,
        value: selectedOption,
        onChange: handleOptionChange,
        variant: "outlined",
        focused: false
    }, data.map(function (item, index) { /*#__PURE__*/ return React.createElement(MenuItem, {
        key: index,
        value: item.value
    }, item.label); })), /*#__PURE__*/ React.createElement(Autocomplete, {
        id: "job-search-select",
        getOptionLabel: function (option) {
            if (selectedOption === "Part") {
                return option.Name + ' (' + '#' + option.SkuCode + ')';
            }
            else {
                return option.Name + ' (' + '#' + option.Code + ')';
            }
        },
        fullWidth: true,
        size: "small",
        options: autocompleteOptions,
        onChange: function (event, newValue) {
            if (newValue !== null) {
                setSearchText('');
                onSelectOption(newValue, selectedOption);
                setAutocompleteOptions([]);
            }
        },
        disabled: isDisabled,
        disableClearable: true,
        inputValue: searchText,
        renderInput: function (params) { /*#__PURE__*/ return React.createElement(TextField, _extends({}, params, {
            sx: {
                "& fieldset": {
                    borderLeft: 'none',
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0
                }
            },
            value: searchText,
            onChange: onChange,
            variant: "outlined",
            focused: false,
            placeholder: selectedOption === "Part" ? 'Search part' : 'Search labour'
        })); }
    }));
};
export default SelectJobsComponent;
